import { makeCustomIcon } from './utils';

export const dimTitanProportionalIcon = makeCustomIcon(
  'TitanProportional',
  32,
  22,
  'm15.214 10.986-8.925-5.153v10.306zm1.572 0 8.925 5.153v-10.306zm8.109-5.629-8.856-5.193-8.896 5.17 8.896 5.136zm-.023 11.274-8.833-5.101-8.873 5.123 8.873 5.183z',
);

export default dimTitanProportionalIcon;
